import type { Messages } from "./en";

export const hi: Messages = {
  app: {
    name: "स्मार्ट क्रॉप प्रोटेक्ट",
    tagline: "आपके खेत का पूर्वानुमान",
    offline: "आप ऑफ़लाइन हैं। सहेजा हुआ डेटा दिखा रहे हैं।",
    updated: (t) => `${t} अपडेट हुआ`,
    staleData: "नया डेटा नहीं मिला। पिछला सहेजा पूर्वानुमान दिखा रहे हैं।",
    loading: "लोड हो रहा है…",
    retry: "फिर कोशिश करें",
    error: "कुछ गड़बड़ हो गई।",
    readAloud: "पढ़कर सुनाएं",
    voice: "आवाज़ से चलाएं",
    listening: "सुन रहे हैं… बोलें: मौसम, स्कैन, पैसा, योजना या होम",
    notHeard: "आवाज़ नहीं सुनाई दी। फिर से बोलें।",
    voiceUnsupported: "इस ब्राउज़र में आवाज़ से चलाना उपलब्ध नहीं है।",
    speechUnsupported: "इस फ़ोन पर पढ़कर सुनाना उपलब्ध नहीं है।",
    change: "बदलें",
    save: "सहेजें",
    cancel: "रद्द करें",
    close: "बंद करें",
    next: "आगे",
    back: "पीछे",
    done: "हो गया",
    seeAll: "सभी देखें",
    viewTable: "तालिका में देखें",
    viewChart: "चार्ट में देखें",
    source: "स्रोत",
    disclaimer:
      "यह सामान्य सलाह है। दवा और मात्रा के लिए उत्पाद लेबल और अपने कृषि अधिकारी या कृषि विज्ञान केंद्र की सलाह मानें।",
  },
  nav: {
    today: "आज",
    field: "खेत",
    scan: "स्कैन",
    money: "पैसा",
    plan: "योजना",
    learn: "जानकारी",
    ai: "AI कैसे काम करता है",
    settings: "सेटिंग्स",
  },
  greet: { morning: "सुप्रभात", afternoon: "नमस्कार", evening: "शुभ संध्या" },
  units: {
    mm: "मिमी",
    kmh: "किमी/घंटा",
    c: "°C",
    kgha: "किग्रा/हेक्टेयर",
    tha: "टन/हेक्टेयर",
    qacre: "क्विंटल/एकड़",
    acres: "एकड़",
    perQuintal: "प्रति क्विंटल",
    perKg: "प्रति किलो",
    days: (n) => `${n} दिन`,
    hours: (n) => `${n} घंटे`,
  },
  level: {
    good: "अच्छा",
    marginal: "ठीक-ठाक",
    poor: "ठीक नहीं",
    none: "नहीं",
    low: "कम",
    moderate: "मध्यम",
    high: "ज़्यादा",
    warning: "चेतावनी",
    serious: "गंभीर",
    critical: "बहुत गंभीर",
  },
  stage: {
    presowing: "अभी बुवाई नहीं हुई",
    initial: "अंकुरण व जमाव",
    development: "बढ़वार",
    mid: "फूल व दाना/फल भराव",
    late: "पकाव",
    harvest: "कटाई के लिए तैयार",
    day: (n) => `${n}वां दिन`,
    sowsIn: (n) => `${n} दिन में बुवाई`,
    harvestIn: (n) => `लगभग ${n} दिन में कटाई`,
    harvestOn: (d) => `अनुमानित कटाई ${d}`,
  },
  onboarding: {
    welcomeTitle: "भरोसे से खेती करें",
    welcomeBody:
      "आपके अपने खेत के लिए मौसम, पानी, कीट-रोग जोखिम और भाव का पूर्वानुमान। सरकारी फसल आंकड़ों और उपग्रह मौसम पर आधारित। बिना इंटरनेट भी चलता है, और आपका डेटा आपके फ़ोन में ही रहता है।",
    start: "शुरू करें",
    languageTitle: "अपनी भाषा चुनें",
    locationTitle: "आपका खेत कहां है?",
    locationBody: "आपकी जगह सिर्फ़ मौसम और मिट्टी की जानकारी लाने में उपयोग होती है। यह इसी फ़ोन में रहती है।",
    useGps: "मेरी जगह पता करें",
    locating: "आपकी जगह ढूंढ रहे हैं…",
    orChoose: "या अपना ज़िला चुनें",
    state: "राज्य",
    district: "ज़िला",
    gpsFailed: "जगह पता नहीं चली। कृपया अपना ज़िला चुनें।",
    outsideIndia: "यह ऐप भारत के लिए है। कृपया ज़िला चुनें।",
    cropTitle: "आप क्या उगा रहे हैं?",
    season: "मौसम",
    sowingDate: "बुवाई की तारीख",
    fieldTitle: "आपके खेत के बारे में",
    area: "खेत का आकार",
    irrigation: "पानी का स्रोत",
    ready: "सब तैयार है",
    readyBody: "आपके खेत का डैशबोर्ड तैयार है।",
  },
  irrigationMethod: { rainfed: "सिर्फ़ बारिश", flood: "नहर / क्यारी सिंचाई", sprinkler: "स्प्रिंकलर", drip: "ड्रिप" },
  today: {
    title: "आज",
    irrigation: "सिंचाई",
    spraying: "छिड़काव",
    pestRisk: "कीट व रोग जोखिम",
    cropStage: "फसल की अवस्था",
    alerts: "मौसम चेतावनी",
    noAlerts: "इस हफ्ते कोई मौसम चेतावनी नहीं।",
    week: "अगले 7 दिन",
    outlook: "उपज व भाव का अनुमान",
    tasks: "अगले काम",
    tip: "आज की सलाह",
    setLocation: "पूर्वानुमान के लिए अपने खेत की जगह चुनें।",
  },
  irrigate: {
    now: (mm) => `आज सिंचाई करें: लगभग ${mm} मिमी`,
    by: (d) => `${d} तक सिंचाई करें`,
    byAmount: (mm, l) => `लगभग ${mm} मिमी (${l} लीटर प्रति एकड़)`,
    hold: (mm, d) => `रुकें: ${d} दिन में ${mm} मिमी बारिश संभव`,
    ok: "अभी सिंचाई की ज़रूरत नहीं",
    okSub: (p) => `जड़ क्षेत्र ${100 - p}% भरा है`,
    rainfedStress: (d) => `${d} से सूखे का तनाव संभव`,
    rainfedSub: "मल्चिंग से नमी बचाएं; हो सके तो जीवनरक्षक सिंचाई दें।",
    notSown: "खेत में अभी बुवाई नहीं हुई",
    harvest: "फसल तैयार है; सिंचाई बंद करें",
    riceFlooded: "खेत में 2–5 सेमी पानी बनाए रखें",
    riceAwd: (n) => `लगभग 5 सेमी पानी भरें: ${n} दिन से अच्छी बारिश नहीं`,
    riceAwdSub: "बारी-बारी से गीला-सूखा करने से बिना उपज घटे लगभग 25% पानी बचता है।",
    riceDrain: "पानी निकाल दें: कटाई पास है",
    logged: "सिंचाई दर्ज की गई",
    logToday: "मैंने आज सिंचाई की",
  },
  spray: {
    goodNow: "अभी छिड़काव का अच्छा समय है",
    window: (a, b) => `सबसे अच्छा समय: ${a}–${b}`,
    none: "2 दिन में छिड़काव का सुरक्षित समय नहीं",
    noneSub: "बारिश, हवा या गर्मी की संभावना। अगले पूर्वानुमान का इंतज़ार करें।",
    reason: {
      "rain-now": "बारिश हो रही है",
      "rain-soon": "4 घंटे में बारिश",
      "wind-high": "तेज़ हवा: दवा उड़ेगी",
      "wind-calm": "हवा बिल्कुल नहीं: दवा ऊपर टिकी रहेगी",
      hot: "बहुत गर्मी",
      "dry-air": "सूखी हवा: बूंदें उड़ जाएंगी",
      humid: "बहुत नमी: देर से सूखेगा",
      dark: "अंधेरा",
    },
    planner: "छिड़काव योजना",
    plannerSub: "अगले 48 घंटे: बारिश, हवा, गर्मी और डेल्टा-T की जांच।",
  },
  risk: {
    none: "इस हफ्ते जोखिम कम",
    noneSub: "मौसम बड़े प्रकोप के अनुकूल नहीं है।",
    title: "कीट व रोग जोखिम",
    sub: "घंटेवार नमी, पत्ती गीलापन और तापमान से संक्रमण का जोखिम।",
    peak: (d) => `${d} को सबसे ज़्यादा`,
    driver: {
      wetness: "पत्तियां लंबे समय गीली",
      "warm-humid": "गर्म और नम",
      "hot-dry": "गर्म और सूखा",
      "cool-humid": "ठंडा और नम",
      "rain-wind": "बारिश और हवा",
      warm: "गर्म मौसम",
    },
  },
  alert: {
    heat: (v) => `लू: ${v}°C तक। शाम को सिंचाई करें, दोपहर में छिड़काव न करें।`,
    cold: (v) => `ठंडी रातें, ${v}°C तक। हल्की सिंचाई से फसल बचती है।`,
    frost: (v) => `पाला पड़ने का खतरा: ${v}°C। शाम को हल्की सिंचाई करें; नर्सरी ढकें।`,
    "heavy-rain": (v) => `भारी बारिश: एक दिन में ${v} मिमी। नालियां खोलें; खाद और छिड़काव टालें।`,
    wind: (v) => `${v} किमी/घंटा तक तेज़ हवा। ऊंची फसल को सहारा दें; छिड़काव न करें।`,
    storm: () => "आंधी-तूफान की संभावना। बिजली चमकने पर खुले खेत में न रहें।",
    hail: () => "ओले गिर सकते हैं। पकी फसल काटें और अनाज सुरक्षित रखें।",
    "dry-spell": (v) => `${v} दिन तक काम की बारिश नहीं। सिंचाई की योजना बनाएं और मल्चिंग करें।`,
  },
  field: {
    title: "खेत",
    sub: "आपकी फसल के लिए मौसम, पानी और सुरक्षा।",
    forecast: "10 दिन का पूर्वानुमान",
    temperature: "तापमान",
    rainfall: "बारिश",
    rainChance: (p) => `${p}% संभावना`,
    max: "अधिकतम",
    min: "न्यूनतम",
    waterTitle: "मिट्टी में पानी",
    waterSub: "आपके जड़ क्षेत्र का FAO-56 जल संतुलन: पिछले 14 दिन और पूर्वानुमान।",
    depletion: "जड़ों के लिए उपलब्ध पानी",
    raw: "तनाव शुरू",
    taw: "खाली",
    irrigationTitle: "सिंचाई सलाह",
    soilTitle: "आपकी मिट्टी",
    soilFrom: "ISRIC SoilGrids (250 मीटर) से",
    soilManual: "आपके चुने प्रकार की सामान्य मिट्टी",
    texture: "बनावट",
    ph: "पीएच",
    awc: "पानी रोकने की क्षमता",
    organicCarbon: "जैविक कार्बन",
    phOk: "पीएच इस फसल के लिए ठीक है",
    phLow: "इस फसल के लिए अम्लीय: मिट्टी जांच के बाद चूना डालने पर विचार करें",
    phHigh: "इस फसल के लिए क्षारीय: मिट्टी जांच के बाद जैविक खाद या जिप्सम डालें",
    today: "आज",
    tomorrow: "कल",
    wind: "हवा",
    humidity: "नमी",
  },
  scan: {
    title: "फसल डॉक्टर",
    sub: "पत्ती की फोटो लें या जो दिख रहा है बताएं। जांच आपके फ़ोन पर ही होती है।",
    photoTab: "फोटो",
    symptomsTab: "लक्षण",
    take: "फोटो लें या चुनें",
    trySample: "पत्ती पास नहीं? नमूना फोटो आज़माएं:",
    tips: "एक रोगी पत्ती को पूरे फ्रेम में, दिन की रोशनी में, साफ़ फोटो लें।",
    analyze: "फोटो जांचें",
    analyzing: "जांच हो रही है…",
    loadingModel: "AI मॉडल लोड हो रहा है (सिर्फ़ पहली बार)…",
    modelUnavailable: "पत्ती का AI मॉडल अभी उपलब्ध नहीं है। सिर्फ़ नुकसान का नक्शा दिखा रहे हैं।",
    results: "नतीजे",
    likely: "सबसे संभावित",
    possible: "यह भी संभव",
    confidence: (p) => `${p}% भरोसा`,
    unsure: "पक्का नहीं कह सकते। एक पत्ती की पास से साफ़ फोटो लें।",
    notLeaf: "यह पत्ती नहीं लगती। एक रोगी पत्ती को पूरे फ्रेम में लेकर फिर कोशिश करें।",
    cropNotCovered:
      "फोटो मॉडल धान, मक्का, कपास, मूंगफली, आलू और टमाटर के लिए है। इस फसल के लिए 'लक्षण' टैब ज़्यादा भरोसेमंद है।",
    healthy: "स्वस्थ दिखती है",
    verify: "खेत की फ़ोटो लैब की फ़ोटो से कठिन होती हैं: छिड़काव से पहले जाँच लें कि नीचे दिए लक्षण आपकी पत्ती से मेल खाते हैं।",
    otherCrop: (c) => `यह ${c} लगती है, आपकी चुनी फसल नहीं।`,
    severity: "पत्ती का खराब हिस्सा",
    severityNote: "पत्ती के रंग से अनुमान। भूरे और पीले हिस्से चिह्नित हैं।",
    whatToDo: "क्या करें",
    signs: "कैसे पहचानें",
    favours: "किस मौसम में बढ़ता है",
    cultural: "खेत के उपाय",
    biological: "जैविक उपाय",
    chemical: "रासायनिक (लेबल के अनुसार)",
    pickSymptoms: "आपको क्या दिख रहा है?",
    findCauses: "संभावित कारण खोजें",
    clear: "साफ़ करें",
    noMatch: "खेत में दिख रहा कम से कम एक लक्षण चुनें।",
    matched: "मिलते लक्षण",
    weatherBoost: "इस हफ्ते का मौसम इसके अनुकूल है",
    saved: "खेत डायरी में सहेजा गया",
    saveLog: "खेत डायरी में सहेजें",
    log: "खेत डायरी",
    logEmpty: "आपके सहेजे स्कैन यहां दिखेंगे और बिना इंटरनेट भी मिलेंगे।",
    privacy: "फोटो आपके फ़ोन से बाहर नहीं जातीं।",
  },
  symptom: {
    spots: "पत्तियों पर धब्बे",
    "eye-lesions": "आंख या नाव जैसे धब्बे, बीच में धूसर",
    "concentric-rings": "निशाने जैसे छल्लों वाले धब्बे",
    "rust-pustules": "जंग जैसे नारंगी पाउडर वाले उभार",
    powder: "पत्तियों पर सफेद पाउडर",
    "water-soaked": "गहरे, पानी से भीगे जैसे धब्बे",
    "white-mould-under": "पत्ती के नीचे सफेद/धूसर फफूंद",
    "purple-patches": "बैंगनी धब्बे",
    "leaf-tip-dry": "पत्ती की नोक/किनारे सूखना",
    yellowing: "पत्तियां पीली होना",
    mosaic: "पीला-हरा चितकबरा पैटर्न",
    "leaf-curl": "पत्तियां मुड़ना या सिकुड़ना",
    silvering: "चांदी जैसी धारियां",
    wilting: "नम मिट्टी में भी मुरझाना",
    stunting: "पौधे की बढ़वार रुकना",
    "rotting-stem": "तना या जड़ के पास सड़न",
    holes: "पत्तियों में छेद या कटी पत्तियां",
    frass: "गोभ में बुरादे जैसा मल",
    "bored-fruit": "फली, टिंडे या फल में छेद",
    "dead-heart": "बीच की कोंपल सूखना",
    "sticky-insects": "छोटे कीड़े, चिपचिपी पत्तियां",
    webbing: "महीन जाले",
    "dry-cracked": "झुलसी पत्तियां, फटी सूखी मिट्टी",
    "standing-water": "खेत में पानी भरा, जड़ें सड़ना",
    lodged: "पौधे ज़मीन पर गिरे",
    weeds: "बहुत खरपतवार",
    "mouldy-grain": "फफूंद लगा या खराब दाना",
    trampled: "जानवरों ने रौंदा या खाया",
  },
  kind: {
    all: "सभी",
    fungal: "फफूंद",
    bacterial: "जीवाणु",
    viral: "विषाणु",
    insect: "कीट",
    mite: "माइट",
    abiotic: "मौसम व मिट्टी",
  },
  money: {
    title: "उपज और पैसा",
    sub: "ज़िले की उपज का पूर्वानुमान, बाज़ार का रुझान और समर्थन मूल्य।",
    yieldTitle: "अनुमानित उपज",
    yieldSub: (d) => `${d} ज़िले के लिए मशीन लर्निंग पूर्वानुमान`,
    range: (a, b) => `संभावित दायरा ${a} – ${b}`,
    vsNormal: (p) => (p >= 0 ? `आपके ज़िले के सामान्य से ${p}% ज़्यादा` : `आपके ज़िले के सामान्य से ${-p}% कम`),
    basedOn: (k, n) =>
      k === 0
        ? "मौसम से पहले: ज़िले के इतिहास और सामान्य मौसम पर आधारित"
        : `इस मौसम के ${n} में से ${k} महीनों का मौसम शामिल`,
    rainSoFar: (p) => `अब तक मौसम की बारिश: सामान्य का ${p}%`,
    scenarioTitle: "अगर बाकी मौसम रहा…",
    dry: "सूखा",
    normal: "सामान्य",
    wet: "ज़्यादा बारिश",
    history: "ज़िले की उपज",
    forecastMark: "पूर्वानुमान",
    noYieldData: "इस फसल और मौसम के ज़िला आंकड़े नहीं हैं, इसलिए उपज पूर्वानुमान नहीं।",
    tomatoNote: "सरकारी ज़िला आंकड़ों में अभी यह फसल शामिल नहीं है।",
    incomeTitle: "आमदनी का अनुमान",
    incomeSub: "खेत का आकार × अनुमानित उपज × भाव।",
    production: "अनुमानित पैदावार",
    priceUsed: "लिया गया भाव",
    grossIncome: "कुल आमदनी",
    mspLabel: (s) => `एमएसपी ${s}`,
    marketLabel: "बाज़ार भाव (पूर्वानुमान)",
    pricesTitle: "बाज़ार भाव का रुझान",
    pricesSub: (z) => `${z} क्षेत्र में खुदरा भाव, 80% पूर्वानुमान दायरे के साथ`,
    latest: (m) => `अंतिम दर्ज (${m})`,
    expected: (m) => `${m} में अनुमानित`,
    noPrice: "इस फसल का बाज़ार भाव आंकड़ा नहीं है। नीचे मंडी के ताज़ा भाव देखें।",
    retailNote: "खुदरा भाव बाज़ार की दिशा बताते हैं; मंडी में आपको मिलने वाला भाव कम होता है।",
    mandiTitle: "आज के मंडी भाव",
    mandiSub: (d) => `एगमार्कनेट थोक भाव, ${d} अपडेट`,
    modal: "मॉडल भाव",
    mspTitle: "न्यूनतम समर्थन मूल्य",
    mspNone: "इस फसल का एमएसपी घोषित नहीं है।",
    helpTitle: "बेचें, बीमा कराएं, मदद लें",
    agmarknet: "मंडी के ताज़ा भाव (एगमार्कनेट)",
    enam: "ऑनलाइन बेचें (ई-नाम)",
    pmfby: "फसल बीमा (पीएमएफबीवाई)",
    kvk: "अपना कृषि विज्ञान केंद्र खोजें",
    kcc: "किसान कॉल सेंटर 1800-180-1551",
    zone: { north: "उत्तर", south: "दक्षिण", east: "पूर्व", west: "पश्चिम", northeast: "पूर्वोत्तर" },
  },
  plan: {
    title: "मौसम की योजना",
    sub: "फसल की समय-रेखा, काम और अगले मौसम के विकल्प।",
    timeline: "फसल की समय-रेखा",
    sowing: "बुवाई",
    harvest: "कटाई",
    tasksTitle: "कामों की सूची",
    addTask: "अपना काम जोड़ें",
    addPlaceholder: "जैसे: उत्तर वाले खेत में नीम छिड़कें",
    add: "जोड़ें",
    advisorTitle: "अगले मौसम में क्या उगाएं",
    advisorSub: (s, d) => `${d} में ${s} के लिए प्रति एकड़ अनुमानित आमदनी के क्रम में फसलें`,
    expectedYield: "अनुमानित उपज",
    perAcre: "प्रति एकड़ आमदनी",
    risk: "खराब साल में",
    noAdvisor: "फसलों की तुलना के लिए ज़िले के पर्याप्त आंकड़े नहीं।",
    stageTasks: {
      initial: [
        "जहां पौधे नहीं उगे वहां खाली जगह भरें",
        "बुवाई के 20–25 दिन बाद पहली निराई",
        "छोटे पौधों में कीट और गलन देखें",
      ],
      development: ["मिट्टी जांच के अनुसार नाइट्रोजन दें", "दूसरी निराई या गुड़ाई", "हफ्ते में दो बार कीट देखें"],
      mid: ["फूल आने पर फसल को सूखने न दें", "फूल और दाने/फलियों को कीटों से बचाएं", "फेरोमोन ट्रैप और पक्षी बैठने के डंडे लगाएं"],
      late: ["कटाई से 10–15 दिन पहले सिंचाई बंद करें", "कटाई के लिए मज़दूर या मशीन तय करें", "भंडार साफ़ करें; बोरियां जांचें"],
      presowing: ["मिट्टी की जांच कराएं", "अनुशंसित किस्म का प्रमाणित बीज खरीदें", "पानी निकासी की नालियां बनाएं"],
      harvest: ["भंडारण से पहले उपज अच्छी तरह सुखाएं", "बेचने से पहले बाज़ार भाव देखें", "फसल अवशेष सुरक्षित हटाएं; जलाएं नहीं"],
    },
  },
  learn: {
    title: "जानकारी",
    sub: "कीट, रोग और फसल नुकसान के अन्य कारण, और उनका प्रबंधन।",
    search: "कीट और रोग खोजें",
    forCrop: (c) => `${c} के लिए खतरे`,
    allCrops: "सभी फसलें",
  },
  settings: {
    title: "सेटिंग्स",
    profile: "आपका खेत",
    location: "जगह",
    crop: "फसल",
    language: "भाषा",
    theme: "रूप",
    themeSystem: "फ़ोन के अनुसार",
    themeLight: "हल्का",
    themeDark: "गहरा",
    textSize: "अक्षर का आकार",
    soil: "मिट्टी का प्रकार",
    soilAuto: "अपने आप (SoilGrids)",
    soilSandy: "रेतीली",
    soilLoamy: "दोमट",
    soilClay: "चिकनी",
    soilBlack: "काली कपास मिट्टी",
    privacy: "गोपनीयता",
    privacyBody:
      "सब कुछ इसी फ़ोन में रहता है। मौसम, मिट्टी और उपग्रह डेटा सार्वजनिक सेवाओं से सिर्फ़ आपके खेत के निर्देशांक से लाया जाता है। न खाता, न ट्रैकिंग।",
    reset: "सारा डेटा मिटाएं",
    resetConfirm: "इस फ़ोन से खेत की जानकारी, काम और सहेजे स्कैन मिटाएं?",
    about: "जानकारी",
    version: (v) => `संस्करण ${v}`,
  },
  tips: [
    "सुबह जल्दी खेत देखें, तब कीट आसानी से दिखते हैं।",
    "पौधे की जड़ में पानी दें ताकि पत्तियां सूखी रहें और रोग कम हों।",
    "हर मौसम फसल बदलें ताकि कीट और रोग का चक्र टूटे।",
    "औज़ार साफ़ रखें ताकि रोग एक खेत से दूसरे में न फैले।",
    "पत्तियों के नीचे देखें, कई कीट वहीं छिपते हैं।",
    "भंडारण से पहले अनाज पूरी तरह सुखाएं।",
    "मेड़ों को खरपतवार से साफ़ रखें, उनमें कीट छिपते हैं।",
  ],
  months: ["जन", "फर", "मार्च", "अप्रै", "मई", "जून", "जुला", "अग", "सितं", "अक्टू", "नवं", "दिसं"],
};
